import { createStore, applyMiddleware, compose, combineReducers } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";
import inventoryReducer from "./reducers/inventory/inventoryReducer";
import progressReducer from "./reducers/progress/progressReducer";
import filterReducer from "./reducers/filter/filterReducer";
import cityReducer from "./reducers/city/cityReducer";
import warehouseReducer from "./reducers/storageWarehouse/warehouseReducer";
import vendorAndBoxigoMarginReducer from "./reducers/vendorAndBoxigoMargin/marginReducer";
import vehicleRecommendationReducer from "./reducers/vehicleRecommendation/vehicleReducer";

const TOGGLE_DISPLAY = 'TOGGLE_DISPLAY';
const SET_DISPLAY_TRUE = 'SET_DISPLAY_TRUE';

export const toggleDisplay = () => {
  return {
    type: TOGGLE_DISPLAY,
  };
};

export const setDisplayTrue = () => {
  return {
    type: SET_DISPLAY_TRUE,
  };
};

const initialDisplayState = {
  toggleSlashRTCDialogBox: false,
};

const displayReducer = (state = initialDisplayState, action) => {
  switch (action.type) {
    case TOGGLE_DISPLAY:
      return {
        ...state,
        toggleSlashRTCDialogBox: !state.toggleSlashRTCDialogBox,
      };
    case SET_DISPLAY_TRUE:
      return {
        ...state,
        toggleSlashRTCDialogBox: true,
      };
    default:
      return state;
  }
};

// Redux dev tools
const composeTools =
  process.env.REACT_APP_ENVIRONMENT === "dev"
    ? composeWithDevTools(applyMiddleware(thunk))
    : compose(applyMiddleware(thunk));

// Root Reducer
export const rootReducer = combineReducers({
  inventoryInfo: inventoryReducer,
  progressInfo: progressReducer,
  displayInfo: displayReducer,
  saveFilter: filterReducer,
  cities: cityReducer,
  storageWarehouse: warehouseReducer,
  vendorAndBoxigoMargin: vendorAndBoxigoMarginReducer,
  vehicleRecommendation: vehicleRecommendationReducer,
});

// Store
export const store = createStore(rootReducer, composeTools);